import clsx from "clsx";
import moment from "moment/moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import style from "./style.module.scss";

const ApplicationCalendar = ({ whenToUse }) => {
  // React i18next
  const { t } = useTranslation();

  // Get the list of months first letter and background theme
  const months = useMemo(
    () =>
      moment.monthsShort().map((string) => {
        let theme = "";
        const monthNumber = moment().month(string).format("M");

        if (whenToUse === "") {
          theme = "noMonth";
        } else {
          if (whenToUse?.best_months?.includes(monthNumber)) {
            theme = "bestMonth";
          } else if (whenToUse?.possible_months?.includes(monthNumber)) {
            theme = "possibleMonth";
          } else if (whenToUse?.no_months?.includes(monthNumber)) {
            theme = "noMonth";
          }
        }

        return {
          firstLetter: string.slice(0, 1),
          theme,
        };
      }),
    [whenToUse]
  );

  return (
    <div className={style.block}>
      <div className={style.overflowCalendar}>
        <div className={style.calendar}>
          {months &&
            months.length > 0 &&
            months.map((month, i) => (
              <div key={i} className={clsx(style.bubble, style[month.theme])}>
                <span className={style.month}>{month.firstLetter}</span>
              </div>
            ))}
        </div>
      </div>

      <div className={style.captions}>
        <div className={style.caption}>{t("Optimale")}</div>
        <div className={style.caption}>{t("Possible")}</div>
        <div className={style.caption}>{t("Not applicable")}</div>
      </div>
    </div>
  );
};

export default ApplicationCalendar;
